import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components

import BlockWrapper from './BlockWrapper';

// ActionCreators

import { changeData } from '../../../actions/ssap/ssapActionCreators';


// Utils

import { normalizeNameOfPerson } from '../../../utils/normalize/normalizeNameOfPerson';
import { normalizeStringToBooleanValue } from '../../../utils/normalize/normalizeStringToBooleanValue';
import { getHhmByPersonId } from '../../../utils/normalize/getHhmByPersonId';
import { convertValuesForReactRender } from '../../../utils/normalize/convertValuesForReactRender';
import { pick } from '../../../utils/miscellaneous/objectHelpers';


const Taxes = props => {

    let {
        data,
        data: {
            taxHousehold: {
                primaryTaxFilerPersonId
            }
        },
        householdMembers,
        id
    } = props;

    const primaryTaxFiler = primaryTaxFilerPersonId ?
        normalizeNameOfPerson(getHhmByPersonId(primaryTaxFilerPersonId, householdMembers).name) :
        'no Primary Tax Filer';

    const handlePTFClick = () => {

        const newState = { ...data };

        newState
            .taxHousehold
            .primaryTaxFilerPersonId =
            (v => normalizeStringToBooleanValue(v, true))(prompt('Enter new value'));

        props.actions.changeData(newState);
    };

    const handleMouseOver = (e, color = undefined) => {
        e.currentTarget.style.backgroundColor = color ? color : 'yellow';
    };

    const handleMouseLeave = (e, color = undefined) => {
        e.currentTarget.style.backgroundColor = color ? color : 'initial';
    };

    return (
        <BlockWrapper id={id}>
            <div>
                <div style={{ margin: '10px 0', fontSize: '1.5rem' }}>
                    Taxes current status
                </div>
                <div
                    onClick={handlePTFClick}
                    style={{ margin: '10px 0', fontSize: '1.2rem', cursor: 'pointer' }}
                    onMouseEnter={handleMouseOver}
                    onMouseLeave={handleMouseLeave}
                >
                    {`Primary Tax Filer : ${primaryTaxFiler}`}
                </div>
                {
                    householdMembers.map((hhm, idx) => {
                        const {
                            applicantGuid,
                            householdId,
                            name,
                            personId,
                            taxHouseholdComposition
                        } = hhm;

                        const selectedTaxHouseholdComposition = pick(
                            taxHouseholdComposition,
                            [
                                'taxFilingStatus',
                                'taxRelationship',
                                'claimerIds',
                                'independentTaxFiler',
                                'livesSeparatelyFromClaimerParent'
                            ]
                        );

                        return (
                            <div
                                key={`${name}_${idx}`}
                                style={{
                                    fontSize: '1.2rem',
                                    marginBottom: '1.2rem'
                                }}
                            >
                                <div style={{ padding: '0.2rem 0' }}>
                                    <span style={{ color: 'yellow' }}>{name ? normalizeNameOfPerson(name) : 'no HM'}</span>
                                    <span style={{ position: 'absolute', left: '220px', fontSize: '1.2rem' }}>{`Person ID: ${personId}`}</span>
                                    <span style={{ position: 'absolute', left: '320px', fontSize: '1.2rem' }}>{`GUID: ${applicantGuid}`}</span>
                                    <span style={{ position: 'absolute', left: '450px', fontSize: '1.2rem' }}>{`Household ID: ${householdId}`}</span>
                                </div>
                                {
                                    Object.entries(selectedTaxHouseholdComposition).map(([ indicator, value ]) => {

                                        return (
                                            <div key={indicator}>
                                                <div
                                                    style={{
                                                        position: 'relative'
                                                    }}
                                                    onMouseEnter={handleMouseOver}
                                                    onMouseLeave={handleMouseLeave}
                                                >
                                                    <span>
                                                        { indicator }
                                                    </span>
                                                    <span
                                                        style={{ position: 'absolute', left: '230px', fontSize: '1.0rem', cursor: 'pointer' }}
                                                    >
                                                        { convertValuesForReactRender(value) }
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        );
                    })

                }
            </div>
        </BlockWrapper>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data,

    householdMembers: state
        .ssap
        .data
        .taxHousehold
        .householdMember
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Taxes);